import { UserProfileModel } from 'mvppoker-portal-common/api'
import React from 'react'
import { FriendsRequestsListItem, FriendsRequestsListItemActions } from './FriendsRequestsListItem'
import './FriendsRequestsModal.scss'

export interface FriendsRequestsModalViewProps
{
	requests: UserProfileModel[],

	clickRefresh: () => void,
	isRefreshing: boolean,
	friendsRequestsListItemActions: FriendsRequestsListItemActions,
}

export const FriendsRequestsModalView : React.FC<FriendsRequestsModalViewProps> = ({ requests, clickRefresh, isRefreshing, friendsRequestsListItemActions }) =>
{
	const items = requests.map((userProfile) => <FriendsRequestsListItem key={userProfile.userId} userProfile={userProfile} {...friendsRequestsListItemActions} />)
	const hasRequests = items.length > 0

	return (
		<>
			<span className='modal-title-l'>FRIEND REQUESTS</span>
			{hasRequests && <div id='friends-requests-list'>
				{items}
			</div>}
			{!hasRequests && <p className="prompt">YOU HAVE NO PENDING REQUESTS AT THE MOMENT</p>}
		</>
	)
}
